import React, { useContext, useEffect, useState } from 'react';
import { Button, Card, Col, Container, Form, Row, Image } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import NotyfContext from '../../contexts/NotyfContext';
import { blankMailingOption, saveMailingOption } from '../../redux/slices/MailingOptionSlice';
import { fetchUploadedDocument, blankUploadDocument } from '../../redux/slices/UploadDocumentSlice';
import { Check } from 'react-feather';
import { callUserActvity, createDisputeLatter, fetchNotification, setNotifcationBedge } from '../../redux/slices/CommonSlice';
import OnboardingSteps from '../../components/new/OnboardingSteps';
import MailOrNot from '../../assets/img/standard-diy.png';
import Factory from '../../assets/img/standard-wd4u.png';
import Loader from '../../components/Loader';

const MailingOption = () => {
  const notyf = useContext(NotyfContext);
  const navigate = useNavigate();
  const [mailOption, setMailOption] = useState(null);
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const dispatch = useDispatch();
  const mailingOptionSave = useSelector(state => state.mailingOption.mailing);
  const mailingOptionData = useSelector(state => state.uploadDocument.uploadDocumentData);
  const uploadDocumentStatus = useSelector(state => state.uploadDocument.status);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  useEffect(() => {
    if (mailingOptionSave && Object.keys(mailingOptionSave).length > 0) {
      if (mailingOptionSave.error == 0) {
        notyf.open({
          type: 'success',
          message: 'Mailing Option saved successfully',
          duration: '3000',
          ripple: false,
          dismissible: false,
          position: {
            x: 'right',
            y: 'top',
          },
        });
        dispatch(blankMailingOption());
        // if (mailOption === 1) {
        //   dispatch(createDisputeLatter());
        // }
        setTimeout(() => {
          navigate('/enhanced-dispute-onboarding');
        }, 3000);
      } else {
        notyf.open({
          type: 'danger',
          message: mailingOptionSave.msg,
          duration: '3000',
          ripple: false,
          dismissible: false,
          position: {
            x: 'right',
            y: 'top',
          },
        });
        setIsSubmitting(false);
      }
      
    }
  }, [mailingOptionSave]);

  useEffect(() => {
    dispatch(fetchUploadedDocument());
  }, []);

  useEffect(() => {
    if (mailingOptionData && Object.keys(mailingOptionData).length > 0) {
      if (mailingOptionData.error === 0) {
        setMailOption(eval(mailingOptionData.response.mailing_option));
      }
    }
  }, [mailingOptionData]);

  const handleSaveMailingOption = () => {
    if(!mailOption){
      notyf.open({
        type: 'danger',
        message: "Kindly Click on one of the mailing options to continue",
        duration: '3000',
        ripple: false,
        dismissible: false,
        position: {
          x: 'right',
          y: 'top',
        },
      });
      return
    }
    setIsSubmitting(true);
    let obj = {
      mailing_option: mailOption,
    };
    dispatch(callUserActvity(`Call Mailing option with ${mailOption === 1 ? 'Mail the disputes out on your Own' : 'Let us mail them out for you!'}`));
    dispatch(saveMailingOption(obj));
    dispatch(fetchNotification());
    dispatch(blankUploadDocument());
    dispatch(setNotifcationBedge(true));
  };

  const mailingOptionElement = (selected, id, text, price) => {
    return id == 2 ? (
      <div onClick={() => setMailOption(id)}>
        <style>
          {`
          @media (max-width: 1284px) {
                #progress {
                  width: 980px !important;
                }
              #progress-complete {
                  width: 790px !important;
                }
              }

              @media (max-width: 992px) {
                #progress {
                  width: 980px !important;
                }
              #progress-complete {
                  width: 790px !important;
                }
              }

              @media (max-width: 768px) {
                #progress {
                  width: 980px !important;
                }
              #progress-complete {
                  width: 790px !important;
                }
              }
          `}
        </style>
        <div className={`border rounded-4 rounded-bottom-0 ${selected && 'border-primary border border-5 rounded-4'} shadow overflow-hidden`}>
          <Card.Header className='text-center'>
            <h4 className='mb-0 py-3 bg-primary text-white'>Have us process and mail them</h4>
          </Card.Header>
          <Card.Body className='d-flex'>
            <Image src={Factory} className='mb-3 mx-auto' style={{ width: '420px' }} />
          </Card.Body>
        </div>
        <div className='card-footer rounded mt-1'>
          <button onClick={() => setMailOption(id)} className='btn btn-primary mx-auto rounded-top-0 rounded text-center py-3 w-100 fs-1 lh-1' style={{ top: '865px', right: '400px' }}>
            ONLY $ {price}!
          </button>
        </div>
      </div>
    ) : (
      <div onClick={() => setMailOption(id)}>
        <div className={`border rounded rounded-bottom-0 ${selected && 'border-secondary border border-5 rounded-4'} shadow overflow-hidden`}>
          <Card.Header className='text-center bg-light text-white py-3'>
            <h4 className='mb-0 text-secondary'>Self Serve - Process & Mail Your Own Letters</h4>
          </Card.Header>
          <Card.Body className='d-flex'>
            <Image src={MailOrNot} className='mb-3 mx-auto' style={{ width: '420px' }} />
          </Card.Body>
        </div>
        <div className='card-footer mt-1'>
          <button className='btn btn-secondary mx-auto rounded-top-0 rounded text-center py-3 w-100 fs-1 lh-1' style={{ top: '865px', left: '300px' }}>
            FREE
          </button>
        </div>
      </div>
    );
  };

  if (isSubmitting) return <Loader />;

  return (
    <React.Fragment>
      <Helmet title='Mailing Option' />

      <Container fluid className='p-0 container-fluid-1335'>
        <div className='row'>
          <div className='col-lg-12'>
            <h3>Disputes creating status</h3>
          </div>
        </div>
        <OnboardingSteps activeStepButtonLeft='-2px' progressComplete='920px' activeStep={5} />

        <Row>
          <Col lg='12' className='text-center pb-5'>
            <h2>Congratulations!</h2>
            <p style={{ color: 'var(--bs-dark-blue)' }}>Your Disputes are being generated! Choose how to mail your dispute letters.</p>
          </Col>
        </Row>
        <Row className='d-flex flex-row mb-5 justify-content-center'>
          <Col xs='12' md='4' className='mb-5'>
            {mailingOptionElement(mailOption === 1, 1, 'Mail the disputes out on your Own', ' Free')}
          </Col>
          <Col xs='12' md='4'>
            {mailingOptionElement(mailOption === 2, 2, 'Let us mail them out for you!', ' 9.99')}
          </Col>
        </Row>
        <Row>
          <Col lg='8' className='d-flex flex-row justfity-content-between py-5 mx-auto'>
            <Button variant='outline-primary' onClick={() => navigate('/upload-document')} className='px-5' type='button' disabled={isButtonClicked}>
              Back
            </Button>
            <Button onClick={() => handleSaveMailingOption()} variant='primary' ms-auto className='px-5 ms-auto' type='submit' style={{ zIndex: '9999999999' }} disabled={isButtonClicked || !mailOption}>
              Continue
            </Button>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default MailingOption;
